"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const repairs = require("./rules/repairs");
function default_1(nodes) {
    repairs.recursive.forEach((repair) => {
        nodes = applyRecursive(nodes, repair);
    });
    repairs.dep.forEach((repair) => {
        nodes = repair(nodes);
    });
    return nodes;
}
exports.default = default_1;
;
function applyRecursive(nodes, repair) {
    return repair(nodes).map((node) => {
        node.left = applyRecursive(node.left, repair);
        node.right = applyRecursive(node.right, repair);
        return node;
    });
}
